/*FINAL*/

/*===============================================================================
=================================================================================
  # GENERALLY HELPFUL FUNCTIONS
=================================================================================
===============================================================================*/

  /*----------------------------------------------------------
    # Set any cookie with name, value and expiration in days - Used by country cookie setter
  ------------------------------------------------------------*/
  function setCookie(cookieName, cookieValue, expiresDays) {
    var d = new Date();
    d.setTime(d.getTime() + (expiresDays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
  }

  /*----------------------------------------------------------
    # Get any cookie based on name and return value  - Used by country cookie setter and b2b cookie
  ------------------------------------------------------------*/
  function getCookie(cookieName) {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  /*----------------------------------------------------------
    # Function to get UTM Parameters then store in a cookie
  ------------------------------------------------------------*/
  (function () {
    function getUTMQueryParam(param) {
        const urlUTMParams = new URLSearchParams(window.location.search);
        return urlUTMParams.get(param);
    }

    function setUTMCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
    }

    function getUTMCookie(name) {
        const nameEQ = name + "=";
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
            let c = cookies[i].trim();
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }

    function getStoredUTM() {
        const cookieValue = getUTMCookie("jd_utm_params");
        return cookieValue ? JSON.parse(cookieValue) : {};
    }

    // List of common multi-part country domains
    const knownPublicSuffixes = [
        "co.uk", "com.au", "co.jp", "co.nz", "co.in", "co.za", "com.sg",
        "com.my", "com.ph", "com.mx", "com.br", "com.tr", "com.ar", "org.uk"
    ];

    // Function to extract the main domain, handling country-code TLDs correctly
    function getMainDomain(hostname) {
        const parts = hostname.split(".");
        if (parts.length < 2) return hostname;

        // Check for known multi-part suffixes
        const lastTwoParts = parts.slice(-2).join(".");
        if (knownPublicSuffixes.includes(lastTwoParts)) {
            return parts.slice(-3).join("."); // e.g., "sub.example.co.uk" → "example.co.uk"
        }

        return lastTwoParts; // Default: keep the last two parts
    }

    // Check if the current URL has UTM parameters
    const hasUTMParams = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"]
        .some(param => getUTMQueryParam(param) !== null);

    // Check if there's a referrer (not the same domain)
    const hasReferrer = document.referrer && new URL(document.referrer).hostname !== window.location.hostname;

    // Extract referrer domain
    const referrerHostname = hasReferrer ? new URL(document.referrer).hostname.replace(/^www\./, '') : null;
    const referrerMainDomain = referrerHostname ? getMainDomain(referrerHostname) : null;

    // Identify Google and Bing searches (including regional domains like google.co.uk)
    const isGoogleSearch = hasReferrer && /google\./.test(referrerHostname);
    const isBingSearch = hasReferrer && /bing\./.test(referrerHostname);

    // Load stored UTM data from cookies
    let utmParams = getStoredUTM();

    // URL UTM parameters take priority
    const urlUTMParams = {
        utm_source: getUTMQueryParam("utm_source"),
        utm_medium: getUTMQueryParam("utm_medium"),
        utm_campaign: getUTMQueryParam("utm_campaign"),
        utm_term: getUTMQueryParam("utm_term"),
        utm_content: getUTMQueryParam("utm_content")
    };

    // Apply URL UTM parameters if they exist
    Object.keys(urlUTMParams).forEach(key => {
        if (urlUTMParams[key] !== null) {
            utmParams[key] = urlUTMParams[key];
        }
    });

    // If utm_source or utm_medium is not in the URL or cookie, fallback to referrer
    if (!utmParams.utm_source || !utmParams.utm_medium) {
        if (isGoogleSearch) {
            utmParams.utm_source = "google";
            utmParams.utm_medium = "organic";
        } else if (isBingSearch) {
            utmParams.utm_source = "bing";
            utmParams.utm_medium = "organic";
        } else if (hasReferrer) {
            // Only set referrer-based source & medium if utm_source and utm_medium are missing
            utmParams.utm_source = utmParams.utm_source || referrerMainDomain;
            utmParams.utm_medium = utmParams.utm_medium || "referral";
        }
    }

    // If still no utm_source or utm_medium, set defaults
    if (!utmParams.utm_source) utmParams.utm_source = "(direct)";
    if (!utmParams.utm_medium) utmParams.utm_medium = "(none)";

    // Store updated values in jd_utm_params cookie for 30 days
    setUTMCookie("jd_utm_params", JSON.stringify(utmParams), 30);
})();






/*----------------------------------------------------------
  # Submit form to Google sheets and send email alerts
------------------------------------------------------------*/
function submitFormToGoogleSheet(sheetId, tabName, emailsToSend) {
  //Uses Google Apps script submitWebsiteFormGeneric

  //Check that all required fields are filled in
  for (const el of document.getElementById('formToSheet')) {
    if (!el.reportValidity()) {
      return;
    }
  }
  
  const scriptURL = 'https://script.google.com/macros/s/AKfycbzENNWFdsjbbQEp-PDIX1Dikc2jzjdv_Z2PwNs15m-p98P9QHaOXFx22wzm2q6XzALl/exec';
  const form = document.forms['formToSheet'];
  
  var today = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');

  var formData = new FormData(form); //Set form data to a variable
  formData.set('sheetId', sheetId); //Add in sheetID
  formData.set('tabName', tabName); //Add in tabName
  formData.set('emailsToSend', emailsToSend); //Add in emails comma seperated
  formData.set('Date', today);

  var utmParamsFromCookie = JSON.parse(getCookie('jd_utm_params')); //Get UTM paramters from our stored cookie

  if(utmParamsFromCookie){
    if(utmParamsFromCookie.utm_source){
      formData.set('Source', utmParamsFromCookie.utm_source); //Add in Source
    } else{
      formData.set('Source', '');
    }
    if(utmParamsFromCookie.utm_medium){
      formData.set('Medium', utmParamsFromCookie.utm_medium); //Add in Medium
    } else {
      formData.set('Medium', '');
    }
    if(utmParamsFromCookie.utm_campaign){
      formData.set('Campaign', utmParamsFromCookie.utm_campaign); //Add in Campaign
    } else {
      formData.set('Campaign', '');
    }
  }

  var formToHide = document.getElementById("formToSheet"); //Get the form
  formToHide.style.display = "none"; //Hide it

  var statusParagraph = document.getElementById("form-status"); //Get the status div
  statusParagraph.innerHTML = '<p class="form-loading-message">Loading, please wait...</p>'; //Add message

  
  
  fetch(scriptURL, {
      method: 'POST',
      body: formData
    })
    .then(response => statusParagraph.innerHTML = '<p class="form-success-message">Success!<br><br>Your details has been submitted, we will be in contact shortly</p>')
    .then(window.lintrk('track', { conversion_id: 20273850 })) //LinkedIn Conversion Tracking
    .then(gtag('event', 'Champions Form Submission'))
    .catch(error => statusParagraph.innerHTML = '<p class="form-failure-message">There seems to have been an error, please try again. If the problem continues, please contact the Jelly Drops team to let us know. ERROR: ' + error.message+'</p>')

}

function championsFormChokingWarningCheck(){
    
    if(document.getElementById('warning-checkbox').checked){ //If they have checked the warning checkbox
      submitFormToGoogleSheet('1-tJ-mwuoheWc8bE4n2hGmC7e4ZH0eavm3UiUxvlxmno','Champions', 'shaun,hello');
    } else {
      document.getElementById("checkout-warning-checkbox-validation").style.display = "block";
      document.getElementById("checkout-warning-checkbox-container").style.backgroundColor = "#ffe8e8";
      document.getElementById("warning-checkbox").scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
    }
  }


/*===============================================================================
=================================================================================
  # ZENDESK LAZY LOAD FUNCTION
=================================================================================
===============================================================================*/
/*OFF AS WE NOW HAVE NON LAZY LOADING FOR PROACTIVE CHAT TRIGGERS*/

/*
document.addEventListener("DOMContentLoaded", function(event) {
	
    function loadZendeskChat(callback) {
      var zdscript = document.createElement('script');
      zdscript.setAttribute('id','ze-snippet');
      zdscript.src = 'https://static.zdassets.com/ekr/snippet.js?key=9197e322-c73e-4ad5-bda9-5fd5bbfd805e';
      (document.getElementsByTagName('body')[0]).appendChild(zdscript);

      window.zdonload = setInterval(function(){
        if(typeof zE !== "undefined" && typeof zE.activate !== "undefined") {
          clearInterval(window.zdonload);
          callback();
        }
      },50,null)
    };
    window.loadAndOpenZendeskChat = function() {
      var button = document.getElementById('zendesk-preload');
      //localStorage.setItem('ff_zd_hasOpened',false);
      button.innerHTML = 'Loading...';
      loadZendeskChat(function(){
        window.setTimeout(function(){
          zE.activate();
          button.parentNode.removeChild(button);
        },1000);
      });
    }
    if(localStorage.getItem('ff_zd_hasOpened')) {
      loadZendeskChat(function(){});
    } else {
      document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend','<button id="zendesk-preload" onClick="window.loadAndOpenZendeskChat();"><span><svg style="color: #FFFFFF;fill: #FFFFFF;vertical-align: middle;" width="20" height="20" viewBox="0 0 20 20" aria-hidden="true"><g id="Layer_4"><path style="fill: #FFFFFF;" d="M11,12.3V13c0,0-1.8,0-2,0v-0.6c0-0.6,0.1-1.4,0.8-2.1c0.7-0.7,1.6-1.2,1.6-2.1c0-0.9-0.7-1.4-1.4-1.4 c-1.3,0-1.4,1.4-1.5,1.7H6.6C6.6,7.1,7.2,5,10,5c2.4,0,3.4,1.6,3.4,3C13.4,10.4,11,10.8,11,12.3z"></path><circle cx="10" cy="15" r="1"></circle><path d="M10,2c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S5.6,2,10,2 M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0 L10,0z"></path></g></svg></span><span>Help</span></button>');
    }
});
*/





/*===============================================================================
=================================================================================
  # GOOGLE TAG MANAGER (GTM) / GOOGLE ANALYTICS (GA) Events
=================================================================================
===============================================================================*/


/*----------------------------------------------------------
  # OLD Cart page standard events (note: page load events & ecommerce events in seperate file)
------------------------------------------------------------*/
function gtmPurchaseTypeSubscription() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Purchase Type',
    'event_label' : 'Subscription',
    
  });
}

function gtmPurchaseTypeOneTimePurchase() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Purchase Type',
    'event_label' : 'One Time Purchase',
    
  });
}  

function gtmSelectFrequencyCta() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Select Frequency CTA',
    'event_label' : 'Clicked',
    
  });
}  

function gtmProductTypeValuePack() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Product Type',
    'event_label' : 'Multipack',
    
  });
}

function gtmProductAmountIncreased() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Product Amount',
    'event_label' : 'Increased',
    
  });
}

function gtmProductAmountDecreased() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Product Amount',
    'event_label' : 'Decreased',
    
  });
}  

function gtmSubscriptionSentCheckbox() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Subscription Sent Today Checkbox',
    'event_label' : 'Clicked',
    
  });
}  

function gtmHealthcareProfessionalLink() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Healthcare Professional Link',
    'event_label' : 'Clicked',
    
  });
}  


function gtmHealthcareProfessionalLink() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Healthcare Professional Link',
    'event_label' : 'Clicked',
    
  });
}  

function gtmShopifySecureLink() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Shopify Secure Link',
    'event_label' : 'Clicked',
    
  });
}  

function gtmWhySubscribeTooltip() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Why Subscribe Tooltip',
    'event_label' : 'Hovered',
    
  });
}    

function gtmHelpMeDecideTooltip() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Help Me Decide Tooltip',
    'event_label' : 'Hovered',
    
  });
}

function gtmValidationErrorChokingCheckbox() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Validation Error',
    'event_label' : 'Choking Checkbox',
    
  });
}

function gtmCartChokingCheckbox() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Choking Checkbox',
    'event_label' : 'Clicked',
    
  });
}  


/*----------------------------------------------------------
  # New Cart Page Events
------------------------------------------------------------*/

function gtmCartBreadcrumbs(breadcrumb) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Breadcrumbs',
    'event_label' : breadcrumb,
    
  });
}

function gtmCartPackTypeSelected(type) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Pack Type Selected',
    'event_label' : type,
    
  });
}  

function gtmCartBuyingOptionSelected(type) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Buying Option Selected',
    'event_label' : type,
    
  });
}  

function gtmCartQuantitySelected(type) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Quantity Selected',
    'event_label' : type,
    
  });
}  

function gtmCartSubscriptionFrequencySelected(type) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Subscription Frequency Selected',
    'event_label' : type,
    
  });
}  

function gtmCartFlavourSelected(type) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Flavour Selected',
    'event_label' : type,
    
  });
}

function gtmCartHelpDecidingSelected(type) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Help Deciding Selected',
    'event_label' : type,
    
  });
}

function gtmCartPackQuantityWarning() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Cart',
    'event_action' : 'Pack Quantity Warning',
    'event_label' : 'Shown',
    
  });
}





/*----------------------------------------------------------
  # Header menu events
------------------------------------------------------------*/
function gtmHeaderMenuItemClicked(event_action, event_label) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Header',
    'event_action' : 'Item Clicked: '+event_action,
    'event_label' : event_label,
    
  });
} 

function gtmHeaderHamburgerClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Header',
    'event_action' : 'Hamburger',
    'event_label' : 'Clicked',
    
  });
}

function gtmHeaderCartClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Header',
    'event_action' : 'Cart',
    'event_label' : 'Clicked',
    
  });
}


function gtmHeaderLogoClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Header',
    'event_action' : 'Logo',
    'event_label' : 'Clicked',
    
  });
}

function gtmHeaderBackToConsumerSiteClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Header',
    'event_action' : 'Back To Consumer Site',
    'event_label' : 'Clicked',
    
  });
}

function gtmHeaderTelephoneLinkClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Header',
    'event_action' : 'Telephone Link',
    'event_label' : 'Clicked',
    
  });
}

function gtmFooterMenuItemClicked(event_action) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Footer',
    'event_action' : 'Item Clicked: '+event_action,
    'event_label' : 'Clicked',
    
  });
}   


/*----------------------------------------------------------
  # Main landing page events
------------------------------------------------------------*/
function gtmHomepageBuyJellyDropsCtaHero() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Buy Jelly Drops CTA',
    'event_label' : 'Hero',
    
  });
}

function gtmHomepageBuyJellyDropsCtaDesignedForDementia() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Buy Jelly Drops CTA',
    'event_label' : 'Designed For Dementia',
    
  });
}

function gtmHomepageBuyJellyDropsCtaAlzheimersSocietyPartners() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Buy Jelly Drops CTA',
    'event_label' : 'Alzheimer\'s Society Partners',
    
  });
}

function gtmHomepageReviewsLinkHero() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Reviews Link',
    'event_label' : 'Hero',
    
  });
}

function gtmHomepageReviewsLinkDesignedForDementia() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Reviews Link',
    'event_label' : 'Designed For Dementia',
    
  });
}

function gtmHomepageReviewsLinkAlzheimersSocietyPartners() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Reviews Link',
    'event_label' : 'Alzheimer\'s Society Partners',
    
  });
}

function gtmHomepageFaqsAccordionClicked(questionName) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'FAQs - Accordion',
    'event_label' : questionName+' - Clicked',
    
  });
}

function gtmHomepageFaqsViewAllClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'FAQs - View All',
    'event_label' : 'Clicked',
    
  });
}

function gtmHomepageSubscribeFormSubmitted() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Subscribe Form',
    'event_label' : 'Submitted',
    
  });
}

function gtmHomepageSocialIconClicked(channelName) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Social',
    'event_label' : channelName+' Icon - Clicked',
    
  });
}


/*----------------------------------------------------------
  # Old Homepage events
------------------------------------------------------------*/

function gtmHomepageSectionCtaClicked(sectionName, buttonText) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Homepage',
    'event_action' : sectionName,
    'event_label' : buttonText+' CTA - Clicked',
    
  });
}

function gtmHomepageMainCtaImage() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Homepage',
    'event_action' : 'Main CTA',
    'event_label' : 'Image - Clicked',
    
  });
}

function gtmHomepageMainCtaButton() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Homepage',
    'event_action' : 'Main CTA',
    'event_label' : 'Button - Clicked',
    
  });
}

function gtmHomepageFeatureCtaClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Homepage',
    'event_action' : 'What Are Jelly Drops?',
    'event_label' : 'Shop Now CTA - Clicked',
    
  });  
}

function gtmColumnsSectionButtonClicked(sectionName, buttonText) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Homepage',
    'event_action' : sectionName,
    'event_label' : buttonText+' CTA - Clicked',
    
  });  
}

function gtmColumnsSectionImageClicked(sectionName) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Homepage',
    'event_action' : sectionName,
    'event_label' : 'Image - Clicked',
    
  });  
}

function gtmHomepageSocialCta(buttonText) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Homepage',
    'event_action' : 'Social',
    'event_label' : buttonText+ ' CTA - Clicked',
    
  });  
}

function gtmHomepageSocialIcons(socialChannel) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Homepage',
    'event_action' : 'Social',
    'event_label' : socialChannel+ ' Icon - Clicked',
    
  });  
}  

/*----------------------------------------------------------
  # Main landing page events
------------------------------------------------------------*/
function gtmMainLandingPageBuyJellyDropsCtaHero() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Buy Jelly Drops CTA',
    'event_label' : 'Hero',
    
  });
}

function gtmMainLandingPageBuyJellyDropsCtaDesignedForDementia() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Buy Jelly Drops CTA',
    'event_label' : 'Designed For Dementia',
    
  });
}

function gtmMainLandingPageBuyJellyDropsCtaAlzheimersSocietyPartners() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Buy Jelly Drops CTA',
    'event_label' : 'Alzheimer\'s Society Partners',
    
  });
}

function gtmMainLandingPageReviewsLinkHero() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Reviews Link',
    'event_label' : 'Hero',
    
  });
}

function gtmMainLandingPageReviewsLinkDesignedForDementia() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Reviews Link',
    'event_label' : 'Designed For Dementia',
    
  });
}

function gtmMainLandingPageReviewsLinkAlzheimersSocietyPartners() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Reviews Link',
    'event_label' : 'Alzheimer\'s Society Partners',
    
  });
}

function gtmMainLandingPageFaqsAccordionClicked(questionName) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'FAQs - Accordion',
    'event_label' : questionName+' - Clicked',
    
  });
}

function gtmMainLandingPageFaqsViewAllClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'FAQs - View All',
    'event_label' : 'Clicked',
    
  });
}

function gtmMainLandingPageSubscribeFormSubmitted() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Subscribe Form',
    'event_label' : 'Submitted',
    
  });
}

function gtmMainLandingPageSocialIconClicked(channelName) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Main Landing Page',
    'event_action' : 'Social',
    'event_label' : channelName+' Icon - Clicked',
    
  });
}

/*----------------------------------------------------------
  # Subscription page events
------------------------------------------------------------*/

function gtmSubscriptionPageBuyingOptionsValuePack() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Subscription Page',
    'event_action' : 'Buying Options',
    'event_label' : 'Multipack CTA - Clicked',
    
  });
}

function gtmSubscriptionPageBuyingOptionsSubscribe() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Subscription Page',
    'event_action' : 'Buying Options',
    'event_label' : 'Subscribe CTA - Clicked',
    
  });
}

function gtmSubscriptionPageFaqsAccordionClicked(questionName) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Subscription Page',
    'event_action' : 'FAQs - Accordion',
    'event_label' : questionName+' - Clicked',
    
  });
}

function gtmSubscriptionPageFaqsViewAllClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Subscription Page',
    'event_action' : 'FAQs - View All',
    'event_label' : 'Clicked',
    
  });
}

/*----------------------------------------------------------
  # Discount page events
------------------------------------------------------------*/

function gtmDiscountPageGetDealCtaClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Discount Page',
    'event_action' : 'Get Deal CTA',
    'event_label' : 'Clicked',
    
  });
} 

function gtmDiscountPageSubscribeFormSubmitted() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Discount Page',
    'event_action' : 'Subscribe Form',
    'event_label' : 'Submitted',
    
  });
}


/*----------------------------------------------------------
  # Country sign Up page events
------------------------------------------------------------*/

function gtmUsaPageSubscribeFormSubmitted() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'USA Page',
    'event_action' : 'Subscribe Form',
    'event_label' : 'Submitted',
    
  });
} 


function gtmCanadaPageSubscribeFormSubmitted() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Canada Page',
    'event_action' : 'Subscribe Form',
    'event_label' : 'Submitted',
    
  });
} 

function gtmEuropePageSubscribeFormSubmitted() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Canada Page',
    'event_action' : 'Subscribe Form',
    'event_label' : 'Submitted',
    
  });
} 



/*----------------------------------------------------------
  # Product page events
------------------------------------------------------------*/

function gtmDetailAccordionClicked(event_label) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Product',
    'event_action' : 'Detail Accordion Clicked',
    'event_label' : event_label,
    
  });
} 

function gtmCommunityReadMoreCTA() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Product',
    'event_action' : 'Community Read More CTA',
    'event_label' : 'Clicked',
    
  });
}

function gtmProductChokingCheckbox() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Product',
    'event_action' : 'Choking Checkbox',
    'event_label' : 'Clicked',
    
  });
}

function gtmProductValidationErrorChokingCheckbox() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Product',
    'event_action' : 'Validation Error',
    'event_label' : 'Choking Checkbox',
    
  });
}

function gtmEmailSignUpSubscribeFormSubmitted() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Email Sign Up',
    'event_action' : 'Subscribe Form',
    'event_label' : 'Submitted',
    
  });
}


/*----------------------------------------------------------
  # Free trial page events
------------------------------------------------------------*/
function gtmFreeTrialPageBuyJellyDropsCtaHero() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Free Trial Page',
    'event_action' : 'Buy Jelly Drops CTA',
    'event_label' : 'Hero',
    
  });
}

function gtmFreeTrialPageBuyJellyDropsCtaHowItWorks() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Free Trial Page',
    'event_action' : 'Buy Jelly Drops CTA',
    'event_label' : 'How It Works',
    
  });
}

function gtmFreeTrialPageReviewsLinkHowItWorks() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Free Trial Page',
    'event_action' : 'Reviews Link',
    'event_label' : 'How It Works',
    
  });
}

function gtmFreeTrialPageFaqsAccordionClicked(questionName) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Free Trial Page',
    'event_action' : 'FAQs - Accordion',
    'event_label' : questionName+' - Clicked',
    
  });
}

function gtmFreeTrialPageFaqsViewAllClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Free Trial Page',
    'event_action' : 'FAQs - View All',
    'event_label' : 'Clicked',
    
  });
}

function gtmFreeTrialPageBuyingOptionsSixPackPack() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Free Trial Page',
    'event_action' : 'Buying Options',
    'event_label' : 'Six Pack CTA - Clicked',
    
  });
}

function gtmFreeTrialPageBuyingOptionsValuePack() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Free Trial Page',
    'event_action' : 'Buying Options',
    'event_label' : 'Multipack CTA - Clicked',
    
  });
}

function gtmFreeTrialPageBuyingOptionsSubscribe() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Free Trial Page',
    'event_action' : 'Buying Options',
    'event_label' : 'Subscribe CTA - Clicked',
    
  });
}

function gtmFreeTrialPageSubscriptionOptions(packs) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Free Trial Page',
    'event_action' : 'Subscription Options',
    'event_label' : packs+' Each Day CTA - Clicked',
    
  });
}


/*----------------------------------------------------------
  # Country localisation events
------------------------------------------------------------*/

function gtmCountryLocalisationUsaSignUpAlertDisplayed() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Country Localisation',
    'event_action' : 'USA Sign Up Alert',
    'event_label' : 'Displayed',
    'eventNonInteraction' : true
  });
}

function gtmCountryLocalisationUsaSignUpAlertClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Country Localisation',
    'event_action' : 'USA Sign Up Alert',
    'event_label' : 'Clicked',
    
  });
}

function gtmCountryLocalisationFlagIconClickedUsa() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Country Localisation',
    'event_action' : 'Flag Icon',
    'event_label' : 'Clicked - USA',
    
  });
}

function gtmCountryLocalisationFlagIconClickedEu() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Country Localisation',
    'event_action' : 'Flag Icon',
    'event_label' : 'Clicked - EU',
    
  });
}

function gtmCountryLocalisationFlagIconClickedCa() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Country Localisation',
    'event_action' : 'Flag Icon',
    'event_label' : 'Clicked - CA',
    
  });
}

function gtmCountryLocalisationFlagIconClickedUk() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Country Localisation',
    'event_action' : 'Flag Icon',
    'event_label' : 'Clicked - UK',
    
  });
}

function gtmCountryLocalisationWarningDisplayed(country) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Country Localisation',
    'event_action' : 'Warning Displayed',
    'event_label' : country,
    'eventNonInteraction' : true
  });
}

function gtmCountryLocalisationChangedTo(country) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Country Localisation',
    'event_action' : 'Changed To',
    'event_label' : country,
    
  });
}

function gtmCountryLocalisationStayedOn(country) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'Country Localisation',
    'event_action' : 'Stayed On',
    'event_label' : country,
    
  });
}


/*----------------------------------------------------------
  # B2B landing page events
------------------------------------------------------------*/

function gtmB2bLandingPageGetBulkDiscountsCtaHero() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Get Bulk Discounts CTA',
    'event_label' : 'Hero',
    
  });
}

function gtmB2bLandingPageGetBulkDiscountsCtaAbout() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Get Bulk Discounts CTA',
    'event_label' : 'About',
    
  });
}

function gtmB2bLandingPageGetBulkDiscountsCtaIngredients() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Get Bulk Discounts CTA',
    'event_label' : 'Ingredients',
    
  });
}

function gtmB2bLandingPageGetBulkDiscountsCtaHydration() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Get Bulk Discounts CTA',
    'event_label' : 'Hydration',
    
  });
}

function gtmB2bLandingPageReviewsLinkHero() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Reviews Link',
    'event_label' : 'Hero',
    
  });
}

function gtmB2bLandingPageReviewsLinkAbout() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Reviews Link',
    'event_label' : 'About',
    
  });
}


function gtmB2bLandingPageReviewsLinkIngredients() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Reviews Link',
    'event_label' : 'Ingredients',
    
  });
}

function gtmB2bLandingPageReviewsLinkHydration() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Reviews Link',
    'event_label' : 'Hydration',
    
  });
}

function gtmB2bLandingPagePartnershipsCtaHero() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Partnerships CTA',
    'event_label' : 'Hero',
    
  });
}

function gtmB2bLandingPageOrderTableTabsSubscribeClicked(tabName) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Order Table Tabs',
    'event_label' : tabName+' - Clicked',
    
  });
}

function gtmB2bLandingPageBulkOrderCtaClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Bulk Order CTA',
    'event_label' : 'Clicked',
    
  });
}

function gtmB2bLandingPageInvoiceCtaClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Invoice CTA',
    'event_label' : 'Clicked',
    
  });
}

function gtmB2bLandingPageChokingCheckboxClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Choking Checkbox',
    'event_label' : 'Clicked',
    
  });
}

function gtmB2bLandingPageChokingCheckboxValidationError() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Choking Checkbox',
    'event_label' : 'Validation Error',
    
  });
}

function gtmB2bLandingPageCheckoutCtaSubscriptionClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Checkout CTA - Subscription',
    'event_label' : 'Clicked',
    
  });
}

function gtmB2bLandingPageCheckoutCtaOtpClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Checkout CTA - OTP',
    'event_label' : 'Clicked',
    
  });
}

function gtmB2bLandingPageCheckoutCtaStarterPackClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Checkout CTA - Starter Pack',
    'event_label' : 'Clicked',
    
  });
}

function gtmB2bLandingPageFaqsAccordionClicked(questionName) {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'FAQs - Accordion',
    'event_label' : questionName+' - Clicked',
    
  });
}

function gtmB2bLandingPageFaqsViewAllClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'FAQs - View All',
    'event_label' : 'Clicked',
    
  });
}

function gtmB2bLandingPageEmailSignUpCtaClicked() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Email Sign Up CTA',
    'event_label' : 'Clicked',
    
  });
}

function gtmB2bLandingPageConsentPopupDisplayed() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Consent Popup',
    'event_label' : 'Displayed',
    'eventNonInteraction' : true
  });
}

function gtmB2bLandingPageConsentPopupAccepted() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Consent Popup',
    'event_label' : 'Accepted',
    
  });
}

function gtmB2bLandingPageGetBulkDiscountsCtaJellyDropsForBusinesses() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Get Bulk Discounts CTA',
    'event_label' : 'Jelly Drops For Businesses',
    
  });
}

function gtmB2bLandingPageBecomeAChampionCtaJellyDropsForBusinesses() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Become A Champion CTA',
    'event_label' : 'Jelly Drops For Businesses',
    
  });
}

function gtmB2bLandingPageBecomeAPartnerCtaJellyDropsForBusinesses() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Landing Page',
    'event_action' : 'Become A Partner CTA',
    'event_label' : 'Jelly Drops For Businesses',
    
  });
}


/*----------------------------------------------------------
  # B2B partnerships page events
------------------------------------------------------------*/
function gtmB2bPartnershipsPagePartnershipsFormSubmitted() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Partnerships Page',
    'event_action' : 'Get Bulk Discounts CTA',
    'event_label' : 'Submitted',
    
  });
}


/*----------------------------------------------------------
  # B2B partnerships page events
------------------------------------------------------------*/
function gtmB2bChampionsPageChampionsFormSubmitted() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Champions Page',
    'event_action' : 'Champions Form',
    'event_label' : 'Submitted',
    
  });
}

/*----------------------------------------------------------
  # B2B large orders page events
------------------------------------------------------------*/
function gtmB2bLargeOrdersPageLargeOrdersFormSubmitted() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Large Orders Page',
    'event_action' : 'Large Orders Form',
    'event_label' : 'Submitted',
    
  });
}

/*----------------------------------------------------------
  # B2B invoices page events
------------------------------------------------------------*/
function gtmB2bInvoicesPageInvoicesFormSubmitted() {
  gtag('event', 'custom_event', {
    
    'event_category' : 'B2B Invoices Page',
    'event_action' : 'Invoices Form',
    'event_label' : 'Submitted',
    
  });
}

